import { Skill, User } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { UserSkillEntityConfig } from "./config";
import { UserSkillFilters } from "./filters";
import { UserSkillMethods } from "./methods";

@HyperEntity("user-skill", UserSkillEntityConfig)
export class UserSkill extends extender(UserSkillFilters, UserSkillMethods) {
  @Fields.string({ dbName: "user_id" })
  userId = "";

  @Fields.string({ dbName: "skill_id" })
  skillId = "";

  @Relations.toOne<UserSkill, Skill>(() => Skill, "skillId")
  skill?: Skill;

  @Relations.toOne<UserSkill, User>(() => User, "userId")
  user?: User;

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt? = new Date();

  @Fields.createdAt({ dbName: "created_at" })
  createdAt? = new Date();
}
